import { Button, Chip, Grid, IconButton, Menu, MenuItem, } from '@material-ui/core';
import { Description, Event, Group, HomeWork, Mail, MoreHoriz, Room, Work } from '@material-ui/icons';
import { getClassesById } from '@webapps/business';
import { useQuery } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import AvatarStudent from 'components/Avatar/AvatarStudent';
import { useState } from 'react'
import { FormattedDate } from 'react-intl';
import AffiliateInfo from './Affiliation';


const CandidatsCard = ({ item, refetch, id, deleteMember, viewMember, contactMember }) => {
  const {
    classes,
    css,
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);

  return (
    <Grid item xs={12} md={4} style={{ padding: spacing(2.5, 2.5, 0, 0) }}>
      <div>
        <div style={{ padding: 20, borderRadius: 10, backgroundColor: '#FFF', }} >
          <div >
            <div>
              <div className={classes.infoCandidat}>
                <div>
                  <AvatarStudent applicant={item?.student} />
                </div>
                <div
                  className={css({
                    marginLeft: spacing(1.5),
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    width: '100%',
                  })}
                >
                  <div
                    className={cx(classes.divStudent, global.title)}
                  >
                    <div style={{ display: 'flex' }}>
                      {item?.student?.lastname}{' '}
                      {item?.student?.firstname}
                    </div>

                  </div>
                  <div className={cx(classes.address, global.infoText)} style={{ marginTop: 0 }}>
                    <Room className={global.infoIcon} />
                    {item?.student?.address?.cityCode}{' '}
                    {item?.student?.address?.city}

                  </div>
                </div>
              </div>
            </div>
            <div>
              <Grid className={cx(classes.address, global.infoText)} style={{ marginTop: spacing(1) }} >
                <AffiliateInfo id={item?.student?.id}
                  school={item?.student?.classroom?.school?.name}
                  refetch={refetch}
                  status={item?.status}
                />
              </Grid>
            </div>
          </div>
        </div>
      </div>
    </Grid>
  )
}



const styles = ({ spacing }) => ({
  formations: {
    marginTop: spacing(2),
  },
  infoCandidat: { display: 'flex', alignItems: 'center', width: '100%' },
  tableHead: {
    '&.MuiTableCell-head': {
      color: 'white',
    },
  },
  address: {
    display: 'flex',
    alignItems: 'center',
    marginTop: spacing(1),
  },
  chip: {
    marginTop: spacing(2),
    padding: spacing(2.5),
    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' }, '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' },
    fontWeight: 'regular',
    '@media only screen and (max-width:768px)': { fontSize: 12, padding: 0, maring: 0 },
  },

  divStudent: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'space-between',
  }
});

export default CandidatsCard